/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, MITSUB_S){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';

	// In Action スライダー
	const inactionSlider = () => {
		if($('.purpose-inAction-slider').length) {
			$('.purpose-inAction-slider').slick({
				infinite: true,
				autoplay: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				speed: 800,
				autoplaySpeed: 5000,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				dots: false,
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					}
				}, {
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					}
				}]
			});
		}
	};

	//  Specific measures スライダー
	const measuresSlider = () => {
		if($('.purpose-measures-slider').length) {
			// tabletとSPのみスライド
			const sliderSetting = () => {
				var width = $(window).width();
				if(width <= 1024) {
					$('.purpose-measures-slider').not('.slick-initialized').slick({
						infinite: true,
						speed: 1000,
						autoplaySpeed: 4000,
						autoplay: true,
						slidesToShow: 1,
						arrows: true,
						prevArrow: arrowPrev,
						nextArrow: arrowNext,
						dots: false,
					});
				} else {
					$('.purpose-measures-slider.slick-initialized').slick('unslick');
				}
			};
			sliderSetting();

			$(window).resize(() =>{
				sliderSetting();
			});
		}
	};

	// ==============================================================================
	
	let _hash = location.hash;
	if(_hash.length) {
		let observer = new MutationObserver((MutationRecords, MutationObserver) => {
			if($('body').css('display') === 'block') {
				inactionSlider();
				measuresSlider();
			}
		});
		observer.observe($('body').get(0), {
			attributes: true,
			attributeFilter: ['style']
		});
	} else {
		inactionSlider();
		measuresSlider();
	}

})(window.jQuery, window.MITSUB_S);
